import { AvatarAPI } from "../apis/avatar";

export async function createAvatarJob(text: string) {
  if (!text) throw new Error("請輸入文字");

  const payload = {
    text,
  };

  const response = await fetch(AvatarAPI.createAvatar().url, {
    method: AvatarAPI.createAvatar().method,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const json = await response.json();

  if (json.stats_code >= 400) {
    alert("job submitted failed");
    console.warn(json);
  }

  return json;
}

export async function getAvatar(id: string) {
  const response = await fetch(AvatarAPI.getAvatar(id).url, {
    method: AvatarAPI.getAvatar(id).method,
  });

  return await response.json();
}
